import { EmailSentEventStatusResponse } from '@dealstack/shared/lib/backendClient';

enum COLOR {
	GREEN = 'green',
	ORANGE = 'orange',
	RED = 'red',
}

const statusColorMap: Record<EmailSentEventStatusResponse, string> = {
	[EmailSentEventStatusResponse.OPENED]: COLOR.GREEN,
	[EmailSentEventStatusResponse.CONVERTED]: COLOR.GREEN,
	[EmailSentEventStatusResponse.CLICKED]: COLOR.GREEN,
	[EmailSentEventStatusResponse.SENT]: COLOR.ORANGE,
	[EmailSentEventStatusResponse.DELIVERED]: COLOR.ORANGE,
	[EmailSentEventStatusResponse.ATTEMPTED]: COLOR.ORANGE,
	[EmailSentEventStatusResponse.UNKNOWN]: COLOR.ORANGE,
	[EmailSentEventStatusResponse.SPAM]: COLOR.RED,
	[EmailSentEventStatusResponse.SUPPRESSED]: COLOR.RED,
	[EmailSentEventStatusResponse.UNDELIVERED]: COLOR.RED,
	[EmailSentEventStatusResponse.UNSUBSCRIBED]: COLOR.RED,
	[EmailSentEventStatusResponse.FAILED]: COLOR.RED,
	[EmailSentEventStatusResponse.BOUNCED]: COLOR.RED,
};

export const mapStatusToColor = (status: EmailSentEventStatusResponse) => {
	return statusColorMap[status];
};
